import NextLink from 'next/link'
import styles from './styles.module.scss'
import { prefixLocale } from '@helpers/env'
import Link from '@components/ui/Link'

const FAQ = {
  title: 'Browse our FAQs',
  href: 'https://help.spoke-london.com/en',
  target: '_blank'
}

const CONTACT_US = {
  title: 'Contact us',
  href: `${prefixLocale()}/pages/contact-us`,
  target: '_self'
}

const SIDEBAR_MAP = {
  orders: [
    FAQ,
    CONTACT_US,
    {
      title: 'Shipping and Delivery',
      href: 'https://help.spoke-london.com/en/categories/4-delivery-and-shipping',
      target: '_blank'
    },
    {
      title: 'Return Policy',
      href: `${prefixLocale()}/pages/return-policy`,
      target: '_self'
    }
  ],
  'your-fit': [FAQ, CONTACT_US],
  'account-details': [
    FAQ,
    CONTACT_US,
    // {
    //   title: 'Update email preferences',
    //   href: 'https://spoke.myklpages.com/p/unsubscribe',
    //   target: '_blank'
    // },
    {
      title: 'Update catalogue preferences',
      href: `${prefixLocale()}/pages/unsubscribe`,
      target: '_self'
    }
  ]
}

export default function Sidebar({ type }: { type?: string }) {
  const sidebarItems =
    SIDEBAR_MAP[
      (type
        ?.trim()
        .replace(' ', '-')
        .toLowerCase() as keyof typeof SIDEBAR_MAP) || 'orders'
    ]
  return (
    <div className={styles.Sidebar}>
      <h4 className={styles.Sidebar__title}>Need help?</h4>
      <ul>
        {sidebarItems?.map(item => (
          <li key={item.title}>
            <NextLink href={item.href} target="_blank" replace shallow={false}>
              <Link underlined={false} href={item.href} target={item.target}>
                {item.title}
              </Link>
            </NextLink>
          </li>
        ))}
      </ul>
    </div>
  )
}
